<template>
    <div>
        <div class="g-group">
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('point')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-point" /></div>
                            <div class="title">点</div>
                        </div>
                        <div @click="baseDraw('billboard')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-billboard" /></div>
                            <div class="title">图标</div>
                        </div>
                        <div @click="baseDraw('polyline3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-line" /></div>
                            <div class="title">线</div>
                        </div>
                        <div @click="baseDraw('bezier')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-curve" /></div>
                            <div class="title">曲线</div>
                        </div>
                        <div @click="baseDraw('polygon2')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-ploygon" /></div>
                            <div class="title">面</div>
                        </div>
                        <div @click="baseDraw('ellipse2')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-circle" /></div>
                            <div class="title">圆</div>
                        </div>
                        <div @click="baseDraw('rectangle2')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-rectangle2" /></div>
                            <div class="title">矩形</div>
                        </div>
                        <div @click="baseDraw('square2')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-rectangle" /></div>
                            <div class="title">正方形</div>
                        </div>
                        <div @click="baseDraw('triangle2')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-triangle" /></div>
                            <div class="title">三角形</div>
                        </div>
                    </div>
                    <div class="text">
                        基础图元
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('polygon3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-hedral" /></div>
                            <div class="title">面体</div>
                        </div>
                        <div @click="baseDraw('sector3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-sector" /></div>
                            <div class="title">扇形</div>
                        </div>
                        <div @click="baseDraw('square3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-cube" /></div>
                            <div class="title">立方体</div>
                        </div>
                        <div @click="baseDraw('triangle')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-triangular" /></div>
                            <div class="title">三棱柱</div>
                        </div>
                        <div @click="baseDraw('ellipse3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-cylinder" /></div>
                            <div class="title">圆柱</div>
                        </div>
                        <div @click="baseDraw('ellipsoid3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-sphere" /></div>
                            <div class="title">球体</div>
                        </div>
                        <div @click="baseDraw('cone3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-cone" /></div>
                            <div class="title">圆锥</div>
                        </div>
                        <div @click="baseDraw('wall3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-wall" /></div>
                            <div class="title">墙体</div>
                        </div>
                        <div @click="baseDraw('polylineVolume3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-pipeline" /></div>
                            <div class="title">管道</div>
                        </div>
                    </div>
                    <div class="text">
                        3D图元
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('straightArrow3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-line-arrow2" /></div>
                            <div class="title">直线箭头</div>
                        </div>
                        <div @click="baseDraw('attackArrow3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-attack-arrow2" /></div>
                            <div class="title">攻击箭头</div>
                        </div>
                        <div @click="baseDraw('pincerArrow3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-pincer" /></div>
                            <div class="title">钳击箭头</div>
                        </div>
                        <div @click="baseDraw('squadCombat')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-combat" /></div>
                            <div class="title">分队战斗</div>
                        </div>
                        <div @click="baseDraw('assaultDirection3')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-direction" /></div>
                            <div class="title">突击方向</div>
                        </div>
                        <div @click="baseDraw('gatheringPlace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-ground" /></div>
                            <div class="title">集结地</div>
                        </div>
                    </div>
                    <div class="text">
                        常用军标
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="save()" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-save" /></div>
                            <div class="title">我的标绘</div>
                        </div>
                        <div @click="clear()" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-clear" /></div>
                            <div class="title">清除</div>
                        </div>
                    </div>
                    <div class="text">
                        操作
                    </div>
                </div>
            </div>
        </div>
        <div class="g-msg">提示:鼠标左键取点，右键结束绘制。(鼠标左键双击标绘即可删除选中标绘)</div>
    </div>
</template>

<script>
import PlotManage from "@/utils/cesiumBD/plot/PlotManage.js";
let plotUti = undefined;
import listPlot from "../VectorPlot/list.vue"; //军事标绘
/*******************UI*********************/
import com_point from "@/components/VectorPlot/compoent/point.vue"
import com_billboard from "@/components/VectorPlot/compoent/billboard.vue"
import com_line from "@/components/VectorPlot/compoent/line.vue"
import com_polygon from "@/components/VectorPlot/compoent/polygon.vue"
import com_circle from "@/components/VectorPlot/compoent/circle.vue"
import com_rectangle from "@/components/VectorPlot/compoent/rectangle.vue"
import com_ellipsoid from "@/components/VectorPlot/compoent/ellipsoid.vue"
import com_cylinder from "@/components/VectorPlot/compoent/cylinder.vue"
import com_wall from "@/components/VectorPlot/compoent/wall.vue"
import com_polylineVolume from "@/components/VectorPlot/compoent/polylineVolume.vue"
export default {
    data() {
        return {

        };
    },

    mounted() {
        plotUti = DBmap.plotUti;

        //plotUti.bindCallbackEdit(this.callbackEdit)
        plotUti.onDbclick(this.dbclick);
    },

    beforeDestroy() {
        plotUti.removeDbclick();
    },

    methods: {
        callbackEdit(entity, evt) {
            var extType = entity.extType;
            var typeList = {
                point_Nor: {
                    name: "点",
                    content: com_point
                },
                billboard_Nor: {
                    name: "图标",
                    content: com_billboard
                },
                polyline_Nor: {
                    name: "线",
                    content: com_line
                },
                bezier_Nor: {
                    name: "曲线",
                    content: com_line
                },
                polygon_Nor: {
                    name: "面",
                    content: com_polygon
                },
                circle_Nor: {
                    name: "圆",
                    content: com_circle
                },
                rectangle_Nor: {
                    name: "圆",
                    content: com_rectangle
                },
                triangle_Nor: {
                    name: "三角形",
                    content: com_polygon
                },
                ellipsoid_Nor: {
                    name: "球体",
                    content: com_ellipsoid
                },
                cylinder_Nor: {
                    name: "圆锥",
                    content: com_cylinder
                },
                wall_Nor: {
                    name: "墙体",
                    content: com_wall
                },
                polylineVolume_Nor: {
                    name: "管道",
                    content: com_polylineVolume
                }
            }

            this.openLayer(typeList[extType].name, typeList[extType].content, entity);
        },
        openLayer(type, content, entity) {
            var ins = this.$dialog.getDialog(`矢量标绘属性编辑${type}`);
            if (ins) {
                //ins.reset();
                ins.close();
                //return;
            }
            this.$dialog.open({
                id: `矢量标绘属性编辑${type}`,
                title: `属性编辑(${type})`,
                theme: "feature-dialog",
                area: {
                    height: "800px",
                    width: "300px",
                },
                location: {
                    top: "80px",
                    left: "20px",
                },
                content: {
                    type: "vue",
                    subCom: content,
                    subData: () => entity
                },
            });
        },
        getPickEnity(pick) {
            if (Cesium.defined(pick) && (pick.id)) {
                return pick.id;
            }

            return null;
        },
        dbclick(evt) {
            let pick = viewer.scene.pick(evt.position);
            var entity = this.getPickEnity(pick);
            // entity.extTag = "BH_Feature";
            if (entity && entity.extTag && entity.extTag == "BH_Feature") {
                this.$confirm("是否删除该矢量标绘？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {

                        if (entity.attrPlot && entity.attrPlot["edit_keyPos"]) {
                            let entities = entity.attrPlot["edit_keyPos"];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_center"]) {
                            let entities = [entity.attrPlot["edit_center"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_rotation"]) {
                            let entities = [entity.attrPlot["edit_rotation"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_height"]) {
                            let entities = [entity.attrPlot["edit_height"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        viewer.entities.remove(entity); //自身

                    })
                    .catch(() => {
                        this.$message({
                            showClose: true,
                            type: "info",
                            message: "本次操作已取消！",
                            duration: 3 * 1000,
                        });
                    });

            }
        },
        baseDraw(type) {
            plotUti.start(type);
        },

        clear() {
            plotUti && plotUti.clear();
        },
        save() {
            //plotUti && plotUti.save();
            var ins = this.$dialog.getDialog("我的标绘");
            if (ins) {
                ins.reset();
                return;
            }
            this.$dialog.open({
                id: "我的标绘",
                title: "我的标绘",
                theme: "feature-dialog",
                area: {
                    height: "800px",
                    width: "500px",
                },
                location: {
                    top: undefined,
                    left: undefined,
                    bottom: "40px",
                    right: "20px"
                },
                content: {
                    type: "vue",
                    subCom: listPlot,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.g-group {
    display: flex;
    flex-direction: row;
}

.g-msg {
    color: #E6A23C;
    font-size: 12px;
    padding: 2px 0 0 10px;
}

.f-group {
    color: #FFFFFF;
    font-size: 12px;
    flex: auto;

    .inner {
        border-right: 1px solid rgba(#FFFFFF, 0.2);

        .list {
            display: flex;

            .item {
                flex: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                cursor: pointer;

                .icon {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .text {
            text-align: center;
            padding-top: 5px;
        }
    }
}
</style>